import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-4" }, "ユーザ編集")
], -1)
const _hoisted_3 = { class: "mt-5 justify-content-center" }
const _hoisted_4 = { class: "d-grid d-md-flex justify-content-md-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success mx-2 mb-2"
}, "更新", -1)

import { ref } from 'vue'
import { useStore } from '@/store'
import { User, Municipality, useNicotto } from '@/plugins/nicotto'
import { useMessenger } from '@/plugins/message'
import UserPage from "@/components/forms/UserPage.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountView',
  setup(__props) {

const store = useStore()
const router = useRouter()
const user = ref(store.state.user as User)
const municipality = ref(user.value.municipality as Municipality)
let email = user.value.email
const nicotto = useNicotto()
const messenger = useMessenger()
const updatePassword = ref<boolean>(false)

const save = async() => {
  try {
    let redirect = '/'
    if (email !== user.value.email) {
      await nicotto.auth.updateEmail(user.value.email)
      store.commit('setEmail', user.value.email)
      email = user.value.email
      redirect = '/account/confirm'
    }
    if (updatePassword.value) {
      await nicotto.auth.updatePassword(user.value.current_password, user.value.new_password)
    }
    user.value.municipality = municipality.value
    await nicotto.auth.updateAccount(user.value)
    messenger.set('user.updateSucceeded')
    router.push(redirect)
  } catch (err) {
    console.log(err)
    messenger.set('user.updateFailed')
  }
}
if (user.value.email_verified === false) {
  messenger.set('user.emailNotVerified')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(UserPage, {
        user: user.value,
        "onUpdate:user": _cache[0] || (_cache[0] = ($event: any) => ((user).value = $event)),
        municipality: municipality.value,
        "onUpdate:municipality": _cache[1] || (_cache[1] = ($event: any) => ((municipality).value = $event)),
        updatePassword: updatePassword.value,
        "onUpdate:updatePassword": _cache[2] || (_cache[2] = ($event: any) => ((updatePassword).value = $event)),
        onSubmit: save
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "btn btn-secondary mx-2 mb-2",
              role: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6
          ])
        ]),
        _: 1
      }, 8, ["user", "municipality", "updatePassword"])
    ])
  ]))
}
}

})